import { ProgressBar } from "primereact/progressbar";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ButtonZegel from "../../components/Buttons/ButtonZegel";
import {
  BuscarCursoID,
  ObtenerProgresoCursoPorPersonaCurso,
} from "../../services/CursoService";
import { ListarUnidadesPorCurso } from "../../services/UnidadService";
import "./styles/ProgresoCurso.scss";


import FooterInterno from "../../components/Footer/FooterInterno";
import useAlumno from "../../hooks/useAlumno";
import { PrivateRoutes } from "../../routes/routes";
import { ListarBibliotecasPorCurso } from "../../services/BibliotecaServices";
import { ListarLeccionesPorUnidad } from "../../services/LeccionServices";
import {
  ActualizarCursoEstado,
  ObtenerCursosPorUsuarioCurso,
  ObtenerPersonaPorId
} from "../../services/UsuarioService";

import moment from "moment";

import { Tooltip } from "primereact/tooltip";
import DialogZegel from "../../components/Dialog/DialogZegel";
import { duracionEnHoras, timeToSeconds } from "../../helpers/helpers";
import { ObtenerEvaluacionesPersonaCurso } from "../../services/EvaluacionService";
import BibliotecaVirtualComponent from "../components/BibliotecaVirtual/BibliotecaVirtualComponent";
import CardBienvenida from "../components/CardBienvenida/CardBienvenida";
import GroupCardDownload from "../components/CardDownload/GroupCardDownload";
import MiProgresoTituloComponent from "../components/MiProgresoTitulo/MiProgresoTituloComponent";
import PreguntasFrecuentesComponent from "../components/PreguntasFrecuentes/PreguntasFrecuentesComponent";
import TabUnidadesComponent from "../components/TabUnidades/TabUnidadesComponent";
import LoadingGlobal from "../components/LoadingGlobal/LoadingGlobal";

const ProgresoCurso = () => {
  const navigate = useNavigate();
  let { perfil } = useAlumno();
  let { configuraciones } = useAlumno();
  let { idCurso } = useParams();
  const [curso, setCurso] = useState({ nombre: "" });
  const [listaUnidades, setListaUnidades] = useState([{ idUnidad: 0 }]);
  const [listaLecciones, setListaLecciones] = useState(null);
  const [listaBiblioteca, setListaBiblioteca] = useState([]);
  const [cursoPersona, setcursoPersona] = useState([{ idEstado: 2 }]);
  const [Persona, setPersona] = useState([]);
  const [isButtonDisabledMateriales, setButtonDisabledMateriales] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingGlobal, setLoadingGlobal] = useState(false);
  const [ProgresoUnidad, setProgresoUnidad] = useState([
    {
      idUnidad: 0,
      promedioPorcentaje: 0,
    },
  ]);
  const [ProgresoCurso, setProgresoCurso] = useState(0);

  const [porcentajeCursoAvance, setPorcentajeCursoAvance] = useState(0);

  const [
    ObtenerProgresoCursoPorPersonaCursoData,
    setObtenerProgresoCursoPorPersonaCursoData,
  ] = useState(null);
  const [ProgresoLeccion, setProgresoLeccion] = useState([
    {
      idUnidad: 0,
      idLeccion: 0,
      PorcentajeAvance: 0,
    },
  ]);
  const [LeccionesPendientes, setLeccionesPendientes] = useState(null);

  const [Evaluaciones, setEvaluaciones] = useState(null);
  const [evaluacionesProgreso, setEvaluacionesProgreso] = useState(null);
  const [spinnerMateriales, setspinnerMateriales] = useState(false);
  const [spinnerCertificado, setspinnerCertificado] = useState(false);
  const [spinnerNotas, setspinnerNotas] = useState(false);


  const [showAlert, setShowAlert] = useState(null);
  const [contenidoAlertActivar, setContenidoAlertActivar] = useState(null);

  const [cursoExpirado, setcursoExpirado] = useState(false);
  const [cursoExpiradoAmpliacion, setCursoExpiradoAmpliacion] = useState(false);
  const [cursoExpiradoMembresia, setCursoExpiradoMembresia] = useState(false);



  useEffect(() => {
    if (
      listaLecciones &&
      ObtenerProgresoCursoPorPersonaCursoData &&
      evaluacionesProgreso
    ) {
      let temppAvance = obtenerPorcentajeAvance(listaLecciones.length);

      setPorcentajeCursoAvance(Math.round(temppAvance));
    }
  }, [
    listaLecciones,
    ObtenerProgresoCursoPorPersonaCursoData,
    evaluacionesProgreso,
  ]);


  useEffect(() => {
    const GetCurso = () => {
      let jwt = window.localStorage.getItem("jwt");
      BuscarCursoID({ jwt, idCurso }).then((data) => {
        if (!data) navigate("/" + PrivateRoutes.HOME + "/Dashboard");

        setCurso(data);
      });
    };

    if (idCurso) GetCurso();
  }, [idCurso]);

  useEffect(() => {
    setLoadingGlobal(true)
    const GetPersonaCurso = async () => {
      let jwt = window.localStorage.getItem("jwt");

      if (perfil != null) {
        var idUsuario = perfil.idUsuario.toString();
        await ObtenerCursosPorUsuarioCurso({ jwt, idUsuario, idCurso }).then(
          async (data) => {
            setcursoPersona(data);
            if (data.length == 0) {
              navigate("/" + PrivateRoutes.HOME + "/Dashboard");
              return;
            }

            if (new Date(data[0].fechaVigencia) < new Date()) {
              if (data[0].fechaAmpliacionCurso) {
                if (new Date(data[0].fechaAmpliacionCurso) < new Date()) {
                  setCursoExpiradoAmpliacion(true);
                }
              }
              setcursoExpirado(true);
            }

            if (data[0].fechaVigenciaMembresia) {
              if (new Date(data[0].fechaVigenciaMembresia) < new Date()) {
                setCursoExpiradoMembresia(true);
                setcursoExpirado(true);
              }
            }

            var idPersona = idUsuario; // data[0].usuario.idPersona
            if (idPersona != undefined) {
              ObtenerPersonaPorId({ jwt, idPersona }).then((dataP) => {
                setPersona(dataP);
              });
            }
            var idPersonaCurso = data[0].idPersonaCurso;
            await ObtenerProgresoCursoPorPersonaCurso({
              jwt,
              idPersonaCurso,
            }).then(async (dataPC) => {
              setObtenerProgresoCursoPorPersonaCursoData(dataPC);
              setListaLecciones(null);
              let jwt = window.localStorage.getItem("jwt");
              var id = idPersonaCurso;
              let porcentajeEva = 0;
              var vLeccionesPendientesUnidades = [];
              await ListarUnidadesPorCurso({ jwt, idCurso }).then(
                async (data) => {
                  setListaUnidades(data);
                  var aux = [];
                  var auxProgresoUnidad = [];
                  var auxProgresoUnidadDataLeccion = [];
                  var auxsLeccionesPendientes = [];
                  var promediosPorUnidad = null;
                  
                  for (var i = 0; i < data.length; i++) {
                    let idUnidad = data[i].idUnidad;
                    await ListarLeccionesPorUnidad({ jwt, idUnidad }).then(
                      (dataLU) => {
                        var vLeccionesPendientesUnidad ={
                          idUnidad: idUnidad,
                          leccionesPendientes:[]
                        }
                        for (var j = 0; j < dataLU.length; j++) {
                          const resultadosFiltrados = dataPC.filter(
                            (item) => item.idLeccion === dataLU[j].idLeccion
                          );
                          var porcentaje = 0;
                          if (resultadosFiltrados.length > 0) {
                            const fechaActual = new Date(
                              resultadosFiltrados[0].tiempoVideoActual
                            );
                            const fechaTotal = new Date(
                              resultadosFiltrados[0].tiempoVideoTotal
                            );
                            const opcionesHora = {
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                            }; 
                            const horaActual = fechaActual.toLocaleTimeString(
                              "es-ES",
                              opcionesHora
                            );
                            const horaTotal = fechaTotal.toLocaleTimeString(
                              "es-ES",
                              opcionesHora
                            );
                            const parteshoraActual = horaActual.split(":");
                            const horashoraActual = parseInt(
                              parteshoraActual[0],
                              10
                            );
                            const minutoshoraActual = parseInt(
                              parteshoraActual[1],
                              10
                            );
                            const segundoshoraActual = parseInt(
                              parteshoraActual[2],
                              10
                            );
                            const parteshoraTotal = horaTotal.split(":");
                            const horashoraTotal = parseInt(
                              parteshoraTotal[0],
                              10
                            );
                            const minutoshoraTotal = parseInt(
                              parteshoraTotal[1],
                              10
                            );
                            const segundoshoraTotal = parseInt(
                              parteshoraTotal[2],
                              10
                            );
                            const totalSegundoshoraActual =
                              horashoraActual * 3600 +
                              minutoshoraActual * 60 +
                              segundoshoraActual + 15;
                            const totalSegundoshoraTotal =
                              horashoraTotal * 3600 +
                              minutoshoraTotal * 60 +
                              segundoshoraTotal;
                            porcentaje = parseInt(
                              (
                                (totalSegundoshoraActual * 100) /
                                totalSegundoshoraTotal
                              ).toFixed(0)
                            );
                            var ProgresoUnidad = {
                              idUnidad: idUnidad,
                              idProgresoCurso:
                                resultadosFiltrados[0].idProgresoCurso,
                              idPersonaCurso:
                                resultadosFiltrados[0].idPersonaCurso,
                              idLeccion: resultadosFiltrados[0].idLeccion,
                              tiempoVideoActual:
                                resultadosFiltrados[0].tiempoVideoActual,
                              tiempoVideoTotal:
                                resultadosFiltrados[0].tiempoVideoTotal,
                              PorcentajeAvance: porcentaje >= 100 ? 100 : porcentaje,
                              cantidadLecciones: dataLU.length,
                            };
                            auxProgresoUnidad.push(ProgresoUnidad);
                          }
                          else{
                            vLeccionesPendientesUnidad.leccionesPendientes.push(j + 1)
                          }
                        }
                        vLeccionesPendientesUnidades.push(vLeccionesPendientesUnidad);
                        var detalleunidad = auxProgresoUnidad.filter(
                          (x) => x.idUnidad == idUnidad
                        );
                        const lecciones = [];
                        for (var k = 0; k < detalleunidad.length; k++) {
                          if (detalleunidad[k].PorcentajeAvance < 100) {
                            lecciones.push(k + 1);
                          } 
                        }
                        var vLeccionesPendientes = {
                          idUnidad: idUnidad,
                          leccionesPendientes: lecciones,
                        };

                        auxsLeccionesPendientes.push(vLeccionesPendientes);
                        const unidadesAgrupadas = {};
                        auxProgresoUnidad.forEach((item) => {
                          if (!unidadesAgrupadas[item.idUnidad]) {
                            unidadesAgrupadas[item.idUnidad] = {
                              totalPorcentaje: 0,
                              cantidadLecciones: 0,
                            };
                          }
                          unidadesAgrupadas[item.idUnidad].totalPorcentaje +=
                            item.PorcentajeAvance;
                          unidadesAgrupadas[item.idUnidad].cantidadLecciones = item.cantidadLecciones;
                        });
                        promediosPorUnidad = Object.entries(
                          unidadesAgrupadas
                        ).map(([unidad, datos]) => ({
                          idUnidad: parseInt(unidad, 10),
                          promedioPorcentaje: parseInt(
                            (datos.totalPorcentaje / datos.cantidadLecciones).toFixed(0)
                          ),
                        }));

                        aux.push(...dataLU);
                      }
                    );
                  }

                  for (var alp = 0; alp < auxsLeccionesPendientes.length; alp++) {
                    for (var lp = 0; lp < vLeccionesPendientesUnidades.length; lp++) {
                      if(vLeccionesPendientesUnidades[lp].idUnidad == auxsLeccionesPendientes[alp].idUnidad){
                        if(auxsLeccionesPendientes[alp].leccionesPendientes.length>0){
                          for(var qa = 0;auxsLeccionesPendientes[alp].leccionesPendientes.length > qa;qa++){
                            //console.log(auxsLeccionesPendientes[alp].leccionesPendientes[qa])
                            vLeccionesPendientesUnidades[lp].leccionesPendientes.push(auxsLeccionesPendientes[alp].leccionesPendientes[qa])
                          }
                        }
                      }
                    }
                  }                 
                  setLeccionesPendientes(vLeccionesPendientesUnidades);
                  //console.log("vLeccionesPendientesUnidades",vLeccionesPendientesUnidades);
                  setProgresoUnidad(promediosPorUnidad);
                  setListaLecciones(aux);
                }
              );
              setLoadingGlobal(false)
            });
          }
        );
      }
    };
    if (perfil != null) {
      GetPersonaCurso();
    }
  }, [perfil]);

  //esv 16-04-25 -1
  useEffect(() => {

    const cargarEvaluaciones = async () => {

        const personaCurso = cursoPersona?.[0];
        const jwt = localStorage.getItem("jwt");
    
        if (!personaCurso?.idPersonaCurso || !listaUnidades?.length || !jwt)  //Validaciones 
        {
          return;
        }
    
        try {
          const id = personaCurso.idPersonaCurso;
          const evaluaciones = await ObtenerEvaluacionesPersonaCurso({ jwt, id });
    
          if (Array.isArray(evaluaciones) && evaluaciones.length > 0) {

            const primerIntento = evaluaciones.filter(e => e.intento === 1);

            const progreso = primerIntento.length > 0   //validad el cálculo 
              ? (primerIntento.length / listaUnidades.length) * 100
              : 0.001;
    
            setEvaluacionesProgreso(progreso);
          } else {
            setEvaluacionesProgreso(0.001);
          }
    
          setEvaluaciones(evaluaciones);
        } catch (error) {
          console.error("Error al obtener las evaluaciones:", error);
          setEvaluacionesProgreso(0.001);
          setEvaluaciones([]);
        }
    };
  
    cargarEvaluaciones();
  }, [cursoPersona, listaUnidades]);

 /* useEffect(() => {
    if (cursoPersona[0].idPersonaCurso && listaUnidades) {
      let id = cursoPersona[0].idPersonaCurso;
      let jwt = window.localStorage.getItem("jwt");
      let porcentajeEva = 0;
      ObtenerEvaluacionesPersonaCurso({ jwt, id }).then(async (dataEva) => {
        if (dataEva && dataEva.length > 0) {
          let dataTemp = dataEva.filter((x) => x.intento == 1);
          if (dataTemp.length > 0) {
            let numUnidades = listaUnidades.length;
            let numEvaRealizadas = dataTemp.length;
            porcentajeEva = (numEvaRealizadas / numUnidades) * 100;
            setEvaluacionesProgreso(porcentajeEva);
          } else {
            setEvaluacionesProgreso(0.001);
          }
        } else {
          setEvaluacionesProgreso(0.001);
        }
        setEvaluaciones(dataEva);
      });
    }
  }, [cursoPersona, listaUnidades]); */  
  //end esv 16-04-25

  useEffect(() => {
    const getBibliteca = async () => {
      let jwt = window.localStorage.getItem("jwt");
      await ListarBibliotecasPorCurso({ jwt, idCurso }).then((data) => {
        setListaBiblioteca(data);
      });
    };
    getBibliteca();
  }, [idCurso]);

  //esv 16-04-25  -2
  function UnidadEvaluacion(props) {
    const { idUnidad } = props;
  
    //validamos datos
    if (!Evaluaciones) {
      return <span className="fontsizesmall">Evaluación: --</span>; 
    }
    // se hace el filter y se guarda
    const evaluacionesUnidad = Evaluaciones.filter((x) => x.idUnidad === idUnidad);
    const progresoUnidad = ProgresoUnidad.find((x) => x.idUnidad === idUnidad);

    //Lógica de Nota Mínima
    const notaMinimaAprob = parseFloat(
      configuraciones?.find((z) => z.codigo === "NOTA_MINIMA_APROB")?.valor ?? 0
    );
  
    if (evaluacionesUnidad.length > 0) {
            
      const notas = evaluacionesUnidad.map((e) => e.nota);  //Array Notas, solo notas de cada Evaluación
      const notaMasAlta = Math.max(...notas);     //calcula la nota más alta en el Array notas
      const cantidadIntentos = notas.length;   //guarda la cantidad de notas y los intentos de evaluacion 

      //Variables descriptivas para style
      const notaFormateada = notaMasAlta <= 9 ? `0${notaMasAlta}` : notaMasAlta;
      const esAprobado = notaMasAlta >= notaMinimaAprob;  
      const claseSpan = (cantidadIntentos === 2 || esAprobado)
        ? "fontsizesmall"
        : "fontsizesmallUnidad";
  
      const colorNota = esAprobado ? "black" : "red";
  
      return (
        <>
          <span className={claseSpan}>
            Evaluación:{" "}
            <span style={{ color: colorNota }}>
              {notaFormateada}
            </span>
          </span>

          {!esAprobado && cantidadIntentos < 2 && (
            <Tooltip
              target=".fontsizesmallUnidad"
              content="¡Recuerda dar tu evaluación! Te queda un intento"
              className="white-tooltip"
              position="left"
            />
          )}

        </>
      );
    }
  
    // progreso mas evaluaciones
    const mostrarTooltip =
      progresoUnidad &&
      ((progresoUnidad.promedioPorcentaje > 0 && progresoUnidad.promedioPorcentaje < 100) ||
        (progresoUnidad.promedioPorcentaje === 100));
  
    const claseSpan = mostrarTooltip
      ? "fontsizesmallUnidad targetTooltip"
      : "fontsizesmall targetTooltip";
  
    return (
      <>
        <span className={claseSpan}>Evaluación: --</span>
        {mostrarTooltip && (
          <Tooltip
            target=".targetTooltip"
            content="¡Recuerda dar tu evaluación! Revisa que hayas completado al menos un intento con nota aprobatoria"
            className="white-tooltip"
            position="left"
          />
        )}
      </>
    );
  } 
   //end esv 16-04-25

  //esv 16-04-25 - 3
  // 1. Devuelve solo el número
  function obtenerPromedioNotasPorUnidad() {

    if (!Evaluaciones || Evaluaciones.length === 0) return 0;  //Validaciones
  
    const notasMaximasPorUnidad = new Map();  //array 
  
    Evaluaciones.forEach(({ idUnidad, nota }) => {    //recorre las evaluaciones por cada una, desestructura 

      const notaMaximaActual = notasMaximasPorUnidad.get(idUnidad) || 0;  //Consulta la nota máxima actual de esa unidad:

      if (nota > notaMaximaActual) {               //compara si la nueva nota es mayor
        notasMaximasPorUnidad.set(idUnidad, nota);  //guarda la nota como la más alta
      }

    });
  
    const sumaNotas = Array.from(notasMaximasPorUnidad.values()).reduce((acc, nota) => acc + nota, 0); //remplaza bucles con reduce()
    const totalUnidades = notasMaximasPorUnidad.size;
    
    //const sumaNotas = 25;
    //const totalUnidades = 2.001;

    const promedio = totalUnidades === 0 ? 0 : sumaNotas / totalUnidades;  //se cálcula el promedio
  
    return parseFloat(promedio.toFixed(2));   //si es con decimales toFixed(2)

  }  
  // 2. Muestra visual del promedio
  const VistaPromedio = (promedio) => {
    const esNumerico = !isNaN(promedio);
    const promedioNum = parseFloat(promedio);
    const promedioAprobado = 13;
  
    const getColor = () =>
      !esNumerico ? "black" : promedioNum < promedioAprobado ? "red" : "black";
  
    return (
      <>
        {esNumerico && (
          <Tooltip
            target=".promedio-tooltip"
            position="top"
            className="white-tooltip"
            content={
              promedioNum < promedioAprobado
                ? "Recuerda que para obtener tu certificado debes contar con al menos 13 puntos en el promedio"
                : "¡Felicitaciones! Obtuviste una nota aprobatoria."
            }
          />
        )}
        <span
          className="subtitle h4 promedio-tooltip"
          data-pr-tooltip={
            promedioNum < promedioAprobado
              ? "Recuerda que para obtener tu certificado debes contar con al menos 13 puntos en el promedio"
              : "¡Felicitaciones! Obtuviste una nota aprobatoria."
          }
        >
          Promedio total del curso:{" "}
          <span style={{ color: getColor(), fontWeight: "bold" }}>{promedio}</span>
        </span>
      </>
    );
  };

 // 3. Combinas para renderizar en pantalla
  const calcularPromedioNotasPorUnidad = () => {
    const promedio = obtenerPromedioNotasPorUnidad();
    return VistaPromedio(promedio ?? "--");
  }; 
 //end esv 16-04-25

  const obtenerPorcentajeAvance = (totalLecciones) => {
    if (ObtenerProgresoCursoPorPersonaCursoData) {
      let porcentajes = [];
      let porcentajesTemp = [];
      let jsonPorcentajes = [];
      ObtenerProgresoCursoPorPersonaCursoData.map((tiempo) => {
        let tiempoa = moment(tiempo.tiempoVideoActual).format("HH:mm:ss");
        let tiempot = moment(tiempo.tiempoVideoTotal).format("HH:mm:ss");

        let porcFinal = (timeToSeconds(tiempoa) / timeToSeconds(tiempot)) * 100;

        jsonPorcentajes.push({
          idLeccion: tiempo.idLeccion,
          porcentaje: porcFinal,
        });
      });

      jsonPorcentajes.forEach((dato) => {
        const { idLeccion, porcentaje } = dato;
        if (
          porcentajesTemp[idLeccion] === undefined ||
          porcentajesTemp[idLeccion] < porcentaje
        ) {
          porcentajesTemp[idLeccion] = porcentaje;
          porcentajes.push(porcentaje);
        }
      });

      const promedioPorcentajes =
        porcentajes.reduce((total, porcentaje) => total + porcentaje, 0) /
        totalLecciones;

      let result =
        (isNaN(promedioPorcentajes) ? 0 : promedioPorcentajes) * 0.5 +
        evaluacionesProgreso * 0.5;
      if (result > 100) {
      }
      return result;
    } else {
      return 0; // evaluacionesProgreso * 0.5;
    }
  };

  // function obtenerPorcentajeAvance() {
  //   if (
  //     ObtenerProgresoCursoPorPersonaCursoData &&
  //     listaLecciones &&
  //     ProgresoUnidad &&
  //     listaUnidades
  //   ) {
  //     const sumaPromedios = ProgresoUnidad.reduce((acumulador, elemento) => {
  //       const promedio = parseFloat(elemento.promedioPorcentaje);
  //       return acumulador + promedio;
  //     }, 0);

  //     const porcentajes = ObtenerProgresoCursoPorPersonaCursoData.map(
  //       (tiempo) => {
  //         let tiempoa = moment(tiempo.tiempoVideoActual).format("HH:mm:ss");
  //         let tiempot = moment(tiempo.tiempoVideoTotal).format("HH:mm:ss");

  //         return (timeToSeconds(tiempoa) / timeToSeconds(tiempot)) * 100;
  //       }
  //     );

  //     const promedioPorcentajes =
  //       porcentajes.reduce((total, porcentaje) => total + porcentaje, 0) /
  //       listaLecciones.length;


  //     var progresoPorcentaje = sumaPromedios / listaUnidades.length / 2;
  //     const unidadesEvaluadas = new Set();
  //     Evaluaciones.forEach((evaluacion) => {
  //       unidadesEvaluadas.add(evaluacion.idUnidad);
  //     });
  //     const cantidadUnidadesEvaluadas = unidadesEvaluadas.size;

  //     var resultado =
  //       (cantidadUnidadesEvaluadas * 100) / listaUnidades.length / 2 +
  //       promedioPorcentajes * 0.5;
  //     return resultado == NaN || resultado == Infinity
  //       ? 0
  //       : resultado.toFixed();
  //   } else {
  //     return evaluacionesProgreso * 0.5;
  //   }
  // }



  const footerActivar = (
    <>
      <div style={{ marginBottom: 8 }}>
        <ButtonZegel
          label="Activar curso"
          color="primary"
          onClick={() => Actualizar()}
        ></ButtonZegel>
      </div>
      <div>
        <ButtonZegel
          label="Cancelar"
          color="secondary"
          onClick={() => setShowAlert(false)}
        ></ButtonZegel>
      </div>
    </>
  );

  const Actualizar = () => {
    setLoading(true);
    let idPersonaCurso = cursoPersona[0].idPersonaCurso;
    let idCurso = cursoPersona[0].idCurso;
    let finCurso = cursoPersona[0].finCurso;
    let idUsuario = cursoPersona[0].idUsuario;
    let idEstado = 2;
    let jsonCurso = JSON.stringify(
      { idPersonaCurso, idUsuario, idCurso, finCurso, idEstado },
      null,
      2
    );
    let jwt = window.localStorage.getItem("jwt");

    ActualizarCursoEstado({ jsonCurso, jwt }).then((data) => {
      setTimeout(() => {
        setShowAlert(false);
        window.location.reload();
      }, 3000);
      setLoading(false);
    });
  };

  //esv 17-04-25 - 4
  function unidadesProbadasNotaMinima(Evaluaciones, configuraciones) {

    if (!Evaluaciones || !configuraciones) return false;  //Validación
  
    const notasMaximasPorUnidad = {};
  
    Evaluaciones.forEach(({ idUnidad, nota }) => {                    //se recorre la evaluaciones, por cada idUnidad se guarda la mas alta de la unidad
      if (!notasMaximasPorUnidad[idUnidad] || nota > notasMaximasPorUnidad[idUnidad]) {  //se validad la mejor nota
        notasMaximasPorUnidad[idUnidad] = nota;
      }
    });
  
    const notaMinima = parseFloat(      //convertimos su valos a numero
      configuraciones.find(z => z.codigo === "NOTA_MINIMA_APROB")?.valor   //obtenemos la nota minma aprobada y se compara  "NOTA_MINIMA_APROB"
    );
  
    //se verifica si alguna nota máxima por unidad es menor que la nota mínima.  //Si alguna lo es, significa que no se aprueba esa unidad. 
    const hayNotasMenores = Object.values(notasMaximasPorUnidad).some(nota => nota < notaMinima);  // con  some() se verifica si alguna nota es menor a la nota mínima.
    return !hayNotasMenores;
  } 
  //end esv 17-04-25

  if (perfil === null) {
    return null;
  }
  return (
    <>
      {<LoadingGlobal loadingGlobal={loadingGlobal} />}
      {

        cursoPersona && cursoPersona.length > 0 && cursoPersona[0].idPersonaCurso &&
        <div className="dashboard-progreso">
          <div className="progreso-header">
            <div className="container-center-auto">
              <button
                className="p-link-button button-img "
                onClick={() => navigate("/" + PrivateRoutes.HOME + "/Dashboard")}
                style={{
                  fontWeight: "bold",
                  color: "#000",
                }}
              >
                <i
                  className="pi pi-arrow-left font-bold"
                  style={{ fontSize: "1rem" }}
                ></i>
              </button>
            </div>
          </div>

          <div className="progreso-contenido content-general-navigation">
            <MiProgresoTituloComponent />

            <CardBienvenida cursoPersona={cursoPersona} Persona={Persona} curso={curso} cursoExpirado={cursoExpirado} porcentajeCursoAvance={porcentajeCursoAvance} cursoExpiradoAmpliacion={cursoExpiradoAmpliacion} cursoExpiradoMembresia = {cursoExpiradoMembresia} Evaluaciones={Evaluaciones} listaUnidades={listaUnidades} spinnerMateriales={spinnerMateriales}
              isButtonDisabledMateriales={isButtonDisabledMateriales} setContenidoAlertActivar={setContenidoAlertActivar} setShowAlert={setShowAlert} setspinnerMateriales={setspinnerMateriales} setButtonDisabledMateriales={setButtonDisabledMateriales}
              setspinnerCertificado={setspinnerCertificado} spinnerCertificado={spinnerCertificado} setspinnerNotas={setspinnerNotas} spinnerNotas={spinnerNotas} unidadesProbadasNotaMinima={unidadesProbadasNotaMinima}
            />
            <GroupCardDownload cursoPersona={cursoPersona}
              isButtonDisabledMateriales={isButtonDisabledMateriales}
              spinnerMateriales={spinnerMateriales}
              setButtonDisabledMateriales={setButtonDisabledMateriales}
              setspinnerMateriales={setspinnerMateriales}
              curso={curso}
              Evaluaciones={Evaluaciones}
              listaUnidades={listaUnidades}
              duracionEnHoras={duracionEnHoras}
              Persona={Persona}
              setspinnerCertificado={setspinnerCertificado}
              spinnerCertificado={spinnerCertificado}
              setspinnerNotas={setspinnerNotas}
              spinnerNotas={spinnerNotas}
            />


            <div className="p-fluid formgrid grid ">
              <TabUnidadesComponent
                listaUnidades={listaUnidades}
                listaLecciones={listaLecciones}
                cursoPersona={cursoPersona}
              />
              <div className="field col-12 md:col-5 progreso-desktop-block">
                <div
                  className="border rounded-9 shadow pt-3 pl-5 pr-2 pb-3 p-md-4 mb-md-4 cardTabs card3Y4min-height"
                // style={{ height: 380 }}
                >
                  <span class="subtitleAvanceUnidades h4" data-v-48f3e599="">
                    Avance de unidades
                  </span>
                  <div style={{ marginLeft: "10px" }}>
                    {listaUnidades.map((item, i) => {
                      console.log('item',item)
                      return (
                        <div className="p-fluid formgrid grid">
                          <div
                            className="field col-12 md:col-2"
                            style={{ paddingLeft: "0", paddingRight: "0" }}
                          >
                            <b className="fontsizesmall">{"Unidad " + (i + 1)}</b>
                          </div>
                          <div className="field col-12 md:col-5 bar-progress-unidades">
                            <Tooltip
                              target={".ProgressBar" + item.idUnidad}
                              content={LeccionesPendientes ?
                                /* ProgresoUnidad.filter((x) => x.idUnidad == item.idUnidad)[0] ? */
                                  ProgresoUnidad.filter((x) => x.idUnidad == item.idUnidad)[0]?.promedioPorcentaje > 0
                                    && ProgresoUnidad.filter((x) => x.idUnidad == item.idUnidad)[0]?.promedioPorcentaje < 100 ? "¡Termina tus videos! Aún no has \nculminado la(s) lección(es): " +
                                  LeccionesPendientes?.filter(
                                    (x) => x.idUnidad == item.idUnidad
                                  )[0].leccionesPendientes?.join(",")

                                    : ""

                                  /* : "¡Termina tus videos! Aún no has \nculminado la(s) lección(es): " +
                                  LeccionesPendientes?.filter(
                                    (x) => x.idUnidad == item.idUnidad
                                  )[0].leccionesPendientes?.join(",") */
                                : ""
                              }
                              position="top"
                              className="white-tooltip"
                            />
                            <ProgressBar
                              className={"ProgressBar" + item.idUnidad}
                              style={{ height: "6px", borderRadius: "0px" }}
                              value={
                                ProgresoUnidad.filter(
                                  (x) => x.idUnidad == item.idUnidad
                                )[0]
                                  ? ProgresoUnidad.filter(
                                    (x) => x.idUnidad == item.idUnidad
                                  )[0].promedioPorcentaje
                                  : 0
                              }
                            ></ProgressBar>
                          </div>
                          <div className={"field col-12 md:col-1 ProgressBar" + item.idUnidad }>
                            <span className="fontsizesmall" style={{ color: "blue" }}>
                              {ProgresoUnidad.filter(
                                (x) => x.idUnidad == item.idUnidad
                              )[0]
                                ? ProgresoUnidad.filter(
                                  (x) => x.idUnidad == item.idUnidad
                                )[0].promedioPorcentaje
                                : "00"}
                              %
                            </span>
                          </div>
                          <div className="field col-12 md:col-4">
                            <UnidadEvaluacion idUnidad={item.idUnidad} />


                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <span class="subtitle h4" data-v-48f3e599="">
                    <span>                      
                      {calcularPromedioNotasPorUnidad()
                        ? calcularPromedioNotasPorUnidad()
                        : "--"}
                    </span>
                  </span>
                </div>
              </div>

              <div className="field col-12 md:col-5 progreso-mobile movilBackground">
                <div className=" rounded-9 shadow p-3 p-md-4 mb-4 mb-md-4 cardTabs">
                  <span class="subtitleAvanceUnidades h4" data-v-48f3e599="">
                    Avance de unidades
                  </span>
                  {listaUnidades.map((item, i) => {
                    return (
                      <div>
                        <div className="contenido-avance-unidad-mobile">
                          <div>
                            <b className="fontsizesmall">{"Unidad " + (i + 1)}</b>
                          </div>
                          <div style={{ marginTop: "7px" }}>
                            <ProgressBar
                              className={"ProgressBar" + item.idUnidad}
                              style={{ height: "8px", borderRadius: "0px" }}
                              value={
                                ProgresoUnidad.filter(
                                  (x) => x.idUnidad == item.idUnidad
                                )[0]
                                  ? ProgresoUnidad.filter(
                                    (x) => x.idUnidad == item.idUnidad
                                  )[0].promedioPorcentaje
                                  : 0
                              }
                            ></ProgressBar>
                          </div>
                          <div>
                            <span className="fontsizesmall" style={{ color: "blue" }}>
                              {ProgresoUnidad.filter(
                                (x) => x.idUnidad == item.idUnidad
                              )[0]
                                ? ProgresoUnidad.filter(
                                  (x) => x.idUnidad == item.idUnidad
                                )[0].promedioPorcentaje
                                : 0}
                              %
                            </span>
                          </div>
                          <div className="field col-12 md:col-3">
                            <UnidadEvaluacion
                              idUnidad={item.idUnidad}
                              className="w-100"
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <span class="subtitle h4" data-v-48f3e599="">
                    <span>                      
                      {calcularPromedioNotasPorUnidad()
                        ? calcularPromedioNotasPorUnidad()
                        : "--"}
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div  style={{marginRight:"8px"}}>
            <BibliotecaVirtualComponent
              listaBiblioteca={listaBiblioteca}
              cursoPersona={cursoPersona}
            />
            </div>
            <div  style={{marginRight:"8px"}}>
            <PreguntasFrecuentesComponent />
            </div>
          </div>
          <FooterInterno />
          <DialogZegel
            header=""
            visible={showAlert}
            width="30vw"
            onHide={() => setShowAlert(false)}
            footer={footerActivar}
            contenido={contenidoAlertActivar}
          ></DialogZegel>
        </div>
      }
    </>


  );
};

export default ProgresoCurso;
